// Top-level locations are "Storage Locations"; anything nested is a "Compartment".
export const locationLabel = (location) =>
  location && location.parentLocationId ? 'Compartment' : 'Storage Location';

const plural = (n, word) => `${n} ${word}${n === 1 ? '' : 's'}`;

// "2 compartments · 5 items", or "Empty", for a card
export function formatCounts({ compartmentCount = 0, itemCount = 0 }) {
  const parts = [];
  if (compartmentCount > 0) parts.push(plural(compartmentCount, 'compartment'));
  if (itemCount > 0) parts.push(plural(itemCount, 'item'));
  return parts.length > 0 ? parts.join(' · ') : 'Empty';
}

// "5 items" for a picker row
export const formatItemCount = (itemCount = 0) => plural(itemCount, 'item');
